// Redux Action Constants
export const P360_CONTACTS_NAMESPACE = 'partner360/contacts'

export const FETCH_CONTACTS = `${P360_CONTACTS_NAMESPACE}/fetchContacts`
export const CREATE_CONTACT = `${P360_CONTACTS_NAMESPACE}/createContact`
export const UPDATE_CONTACT = `${P360_CONTACTS_NAMESPACE}/updateContact`
export const DELETE_CONTACT = `${P360_CONTACTS_NAMESPACE}/deleteContact`
export const UPLOAD_CONTACT_IMAGE = `${P360_CONTACTS_NAMESPACE}/uploadContactImage`

// Translation Constants
export const TRANSLATION_NAMESPACE = 'jbp-partner-contacts'

export const TRANSLATION_KEYS = {
  widgetTitle: 'jbp-contacttable-title',

  imageUploader: {
    browse: `${TRANSLATION_NAMESPACE}--image-uploader--browse`,
  },
  emptyList: 'jbp-contacttable--empty-list',
  emptySearchResult: 'jbp-contacttable--empty-search-result',

  addToTheList: 'jbp-contacttable--add-to-the-list',
  editList: 'jbp-contacttable--edit-list',
}
